import { render, staticRenderFns } from "./PripadyWizardNajomca.vue?vue&type=template&id=2f16960d&"
import script from "./PripadyWizardNajomca.vue?vue&type=script&lang=js&"
export * from "./PripadyWizardNajomca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VContainer,VDialog,VForm,VIcon,VImg,VRow,VSpacer,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f16960d')) {
      api.createRecord('2f16960d', component.options)
    } else {
      api.reload('2f16960d', component.options)
    }
    module.hot.accept("./PripadyWizardNajomca.vue?vue&type=template&id=2f16960d&", function () {
      api.rerender('2f16960d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pripady_wizard/PripadyWizardNajomca.vue"
export default component.exports